module.exports = __webpack_public_path__ + "static/3-cc995aa7b4cb7c62328afbc229c2df34.jpg";